<template>
  <div class="adx-group-button">
    <ul>
      <li v-for="item in list" :key="item.id " @click.stop="selected(item)">
        <span :class="[isActive == item.id ? 'active': '', isDisabled.includes(item.value) ? 'disabled': '']">{{ item.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'adx-group-button',
  props: {
    list: {
      type: Array,
      required: true,
    },
    isDisabled: {
      type: Array,
      required: false,
    },
  },
  data(){
    return{
      isActive: null,
    }
  },
  computed :{

  },
  methods:{
    selected(item){
      this.$emit('selectedButton', item.value)
      this.isActive = item.id
    }
  }
}

</script>

<style lang='scss' scoped>
@import './index.scss';
</style>